export default __webpack_public_path__ + "static/media/logo.a2083ab7.png";